import { localDate } from '@/platform/lib/utils';

export const groupByQuestion = questions => [
    ...questions
        .reduce((groups, row) => {
            if (!groups.has(row.question_id)) {
                groups.set(row.question_id, {
                    id: row.question_id,
                    question: row.question,
                    options: [],
                });
            }

            groups.get(row.question_id).options.push(row);

            return groups;
        }, new Map())
        .values(),
];

export const questionnaireSubtitle = (employee, questionnaire) =>
    [
        employee.name,
        `Aangemaakt: ${localDate(questionnaire.created_at)}`,
        questionnaire.completed_at &&
            `Afgerond: ${localDate(questionnaire.completed_at)}${questionnaire.completed_by ? ` door ${questionnaire.completed_by}` : ''}`,
    ]
        .filter(Boolean)
        .join(' · ');
